import { startRegistration, startAuthentication, browserSupportsWebAuthn } from '@simplewebauthn/browser'
import Api from './Api'

export const passkeyApi = {
  supported: () => browserSupportsWebAuthn(),

  async list () {
    const res = await Api.get('/passkey')
    return res.ok ? res.data.data : []
  },

  async register (nome) {
    const options = await Api.post('/passkey/register/options')
    if (!options.ok) throw new Error('passkey-options')
    const response = await startRegistration({ optionsJSON: options.data.data })
    const verified = await Api.post('/passkey/register/verify', { response, nome })
    if (!verified.ok) throw new Error('passkey-verify')
  },

  remove: (credentialId) => Api.delete(`/passkey/${encodeURIComponent(credentialId)}`),

  async login () {
    const options = await Api.post('/passkey/login/options')
    if (!options.ok) return false
    const response = await startAuthentication({ optionsJSON: options.data.data })
    return Api.finishSession(await Api.post('/passkey/login/verify', { response }))
  }
}
